/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle, useLayout } from '../../../_metronic/layout/core'
import { EngageWidget10 } from '../../../_metronic/partials/widgets'
import { CardsWidget171 } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget171'
import StatisticsWidgetClient from '../../../_metronic/partials/widgets/statistics/StatisicsWidgetClient'
import CardsDashboardMain from '../../../_metronic/partials/widgets/_new/cards/CardsDashboardMain'
import { axiosClientAuth } from '../../utils'
import {REGULATORY_OPERATOR_KEY} from '../../../config/countryConfig'

const DashboardPage: FC = () => {
  const intl = useIntl()
  const { setLayoutType } = useLayout()
  const [urlStats, setUrlStats] = useState<{ whitelisted: number; blacklisted: number; pending: number } | null>(null)
  const [peData, setPeData] = useState<any>(null)
  const [tmCount, setTmCount] = useState<number | null>(null)

  useEffect(() => {
    setLayoutType('dark-header')
    axiosClientAuth.get('/analytics/resources/')
      .then((res) => {
        const urlData = res.data?.data?.url ?? {}
        const byOp = urlData.by_operator?.[REGULATORY_OPERATOR_KEY] ?? {}
        setUrlStats({
          whitelisted: byOp.whitelisted ?? 0,
          blacklisted: byOp.blacklisted ?? 0,
          pending: byOp.pending ?? 0,
        })
      })
      .catch(() => {})
    axiosClientAuth.get('/auth/users/', { params: { type: 'PE', page: 1, page_size: 5 } })
      .then((res) => {
        const { count, results } = res.data.data
        setPeData({
          pe_users: count,
          pe_initials: results.map((r: any) => r.name.charAt(0).toUpperCase()),
        })
      })
      .catch(() => {})
    axiosClientAuth.get('/auth/users/', { params: { type: 'TM', page: 1, page_size: 1 } })
      .then((res) => setTmCount(res.data.data.count as number))
      .catch(() => {})
  }, [])

  const whitelisted = intl.formatMessage({ id: 'COMMON.WHITELISTED', defaultMessage: 'Whitelisted' })
  const blacklisted = intl.formatMessage({ id: 'COMMON.BLACKLISTED', defaultMessage: 'Blacklisted' })
  const pending = intl.formatMessage({ id: 'COMMON.PENDING', defaultMessage: 'Pending' })

  return (
    <>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-3 col-lg-3 col-xl-7 col-xxl-7'>
          <CardsDashboardMain data={{vendor_users_count: tmCount ?? 0}} className='h-100' />
        </div>
        <div className='col-md-2 col-lg-2 col-xl-5 col-xxl-5'>
          <CardsWidget171
            className='card-xl-stretch mb-xl-8 h-100'
            mLables={{
              [whitelisted]: urlStats?.whitelisted ?? 0,
              [blacklisted]: urlStats?.blacklisted ?? 0,
              [pending]: urlStats?.pending ?? 0,
            }}
            mColors={{ [whitelisted]: 'bg-success', [blacklisted]: 'bg-danger', [pending]: 'bg-warning' }}
            heading={intl.formatMessage({ id: 'URL.SUMMARY', defaultMessage: 'URL Summary' })}
            subHeading='URLs'
          />
        </div>

        <div className='col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
          <StatisticsWidgetClient data={peData} className='h-100 mb-5 mb-xl-10' />
        </div>
        <div className='col-md-8 col-lg-8 col-xl-8 col-xxl-8'>
          <EngageWidget10 data={undefined} className='h-md-100 bg-primary' />
        </div>
      </div>
    </>
  )
}

const myBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const { setRightTolbar } = useLayout()

  useEffect(() => {
    setRightTolbar('dashboard')
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      </PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
